export const mbcClassEntryModule = 'mbcClassEntry';

export const SEARCHABLE_ROSTER_MIN = 9;
